<template>
  <CourseForm :typeEndPoint="'academicCoursesFrom'" :dataParams="{}"/>
</template>
<script>
import CourseForm from '@/components/modules/academic/courses/form'
export default {
  name: 'academicCourseFormCreate',
  components: {
    CourseForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/academic/courses/create.vue